import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const FieldInspector: React.FC = () => {
  return (
    <PageTemplate
      title="Field Inspector"
      description="Inspect and analyze field metadata"
    />
  );
};